import { RerunTypeMap } from '../../constants/test';
import {
  CLEAR_RERUN_TEST_DETAILS,
  CLEAR_RERUN_TEST_HISTORY,
  DEBUGGER_STATE_FAILED,
  DEBUGGER_STATE_LOADING,
  DEBUGGER_STATE_SUCCESS,
  FETCH_ACTIVE_TUNNEL_LIST_FAILED,
  FETCH_ACTIVE_TUNNEL_LIST_LOADING,
  FETCH_ACTIVE_TUNNEL_LIST_SUCCESS,
  FETCH_ALL_BREAKPOINTS_FAILED,
  FETCH_ALL_BREAKPOINTS_LOADING,
  FETCH_ALL_BREAKPOINTS_SUCCESS,
  FETCH_SIMILAR_TEST_REPRODUCE_LIST_FAILED,
  FETCH_SIMILAR_TEST_REPRODUCE_LIST_LOADING,
  FETCH_SIMILAR_TEST_REPRODUCE_LIST_SUCCESS,
  FETCH_SIMILAR_TEST_RETRY_LIST_FAILED,
  FETCH_SIMILAR_TEST_RETRY_LIST_LOADING,
  FETCH_SIMILAR_TEST_RETRY_LIST_SUCCESS,
  FETCH_TEST_REPRODUCE_HISTORY_FAILED,
  FETCH_TEST_REPRODUCE_HISTORY_LOADING,
  FETCH_TEST_REPRODUCE_HISTORY_SUCCESS,
  FETCH_TEST_RETRY_HISTORY_FAILED,
  FETCH_TEST_RETRY_HISTORY_LOADING,
  FETCH_TEST_RETRY_HISTORY_SUCCESS,
  LAMBDATEST_PARENT_TEST_DETAIL_FAILED,
  LAMBDATEST_PARENT_TEST_DETAIL_LOADING,
  LAMBDATEST_PARENT_TEST_DETAIL_SUCCESS,
  MODIFY_BREAKPOINT_FAILED,
  MODIFY_BREAKPOINT_LOADING,
  MODIFY_BREAKPOINT_SUCCESS,
  PAUSE_REPLAY_TEST_FAILED,
  PAUSE_REPLAY_TEST_LOADING,
  PAUSE_REPLAY_TEST_SUCCESS,
  RERUN_TEST_FAILED,
  RERUN_TEST_LOADING,
  RERUN_TEST_SUCCESS,
  RESET_ACTIVE_TUNNEL_LIST,
  RESET_SIMILAR_TEST_LIST,
  RESUME_REPLAY_TEST_FAILED,
  RESUME_REPLAY_TEST_LOADING,
  RESUME_REPLAY_TEST_SUCCESS,
  SET_IS_RERUN_ADVANCED_SETTINGS_MODE,
  SET_IS_RERUN_EDIT_CAPABILITY_MODE,
  SET_IS_RERUN_PAGE,
  SET_RERUN_FULLSCREEN_MODE,
  SET_RERUN_TEST_DETAILS,
  SET_RERUN_TYPE,
  STEPOVER_REPLAY_TEST_FAILED,
  STEPOVER_REPLAY_TEST_LOADING,
  STEPOVER_REPLAY_TEST_SUCCESS,
  STOP_REPLAY_TEST_FAILED,
  STOP_REPLAY_TEST_LOADING,
  STOP_REPLAY_TEST_SUCCESS,
  UPDATE_PLAYBACK_SPEED_FAILED,
  UPDATE_PLAYBACK_SPEED_LOADING,
  UPDATE_PLAYBACK_SPEED_SUCCESS,
  UPDATE_SELECTED_TEST_TO_REPRODUCE,
  UPDATE_SELECTED_TEST_TO_RETRY,
  UPDATE_TEST_ATTEMPTS,
  UPDATE_DEBUGGER_STATE,
  UPDATE_TEST_DETAILS_FAILED,
  UPDATE_TEST_DETAILS_LOADING,
  UPDATE_TEST_DETAILS_SUCCESS,
  UPDATE_COMMAND_BREAKPOINT,
  UPDATE_UNSAVED_CAPABILITY,
} from '../actionTypeConstants/rerunTestConstants';

const initialState = {
  rerunType: RerunTypeMap.REPLAY,
  isTestRerunPage: false,
  isRerunEditCapabilityEnabled: false,
  isRerunAdvancedSettingsEnabled: false,
  fullScreenMode: false,
  unsavedCapability: null,
  activeTunnelList: {
    isLoading: false,
    data: [],
    error: null,
  },
  similarTestRetryList: {
    isLoading: false,
    data: [],
    selectedTest: null,
    error: null,
  },
  parentTestDetailHash: {
    isLoading: false,
    data: {},
    error: null,
  },
  similarTestReproduceList: {
    isLoading: false,
    data: [],
    selectedTest: null,
    error: null,
  },
  testRetryHistory: {
    isLoading: false,
    data: {},
    error: null,
  },
  testReproduceHistory: {
    isLoading: false,
    data: {},
    error: null,
  },
  updateTestDetails: {
    isLoading: false,
    data: {},
    error: null,
  },
  rerunTestDetails: {
    speed: 1,
    breakpoints: [],
  },
  rerunTest: {
    isLoading: false,
    data: {},
    error: null,
  },
  stopTest: {
    isLoading: false,
    data: {},
    error: null,
  },
  pauseTest: {
    isLoading: false,
    data: {},
    error: null,
  },
  resumeTest: {
    isLoading: false,
    data: {},
    error: null,
  },
  stepoverCommand: {
    isLoading: false,
    data: {},
    error: null,
  },
  debuggerState: {
    isLoading: false,
    currentParentRequestId: null,
    currentDebuggerState: null,
    speed: 1,
    error: null,
  },
  modifyBreakpoint: {
    isLoading: false,
    data: {},
    error: null,
  },
  breakpointDetails: {
    isLoading: false,
    data: [],
    error: null,
  },
  updatePlaybackSpeed: {
    isLoading: false,
    data: {},
    error: null,
  },
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_ACTIVE_TUNNEL_LIST_LOADING: {
      return {
        ...state,
        activeTunnelList: {
          ...state.activeTunnelList,
          isLoading: true,
        },
      };
    }

    case FETCH_ACTIVE_TUNNEL_LIST_SUCCESS: {
      return {
        ...state,
        activeTunnelList: {
          ...state.activeTunnelList,
          isLoading: false,
          data: action?.result?.data,
        },
      };
    }

    case FETCH_ACTIVE_TUNNEL_LIST_FAILED: {
      return {
        ...state,
        activeTunnelList: {
          ...state.activeTunnelList,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case FETCH_SIMILAR_TEST_RETRY_LIST_LOADING: {
      return {
        ...state,
        similarTestRetryList: {
          ...state.similarTestRetryList,
          isLoading: true,
        },
      };
    }

    case FETCH_SIMILAR_TEST_RETRY_LIST_SUCCESS: {
      const testData = action?.result?.data;
      return {
        ...state,
        similarTestRetryList: {
          ...state.similarTestRetryList,
          isLoading: false,
          data: testData,
          selectedTest: testData?.tests?.[0]?.id,
        },
      };
    }

    case FETCH_SIMILAR_TEST_RETRY_LIST_FAILED: {
      return {
        ...state,
        similarTestRetryList: {
          ...state.similarTestRetryList,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case FETCH_SIMILAR_TEST_REPRODUCE_LIST_LOADING: {
      return {
        ...state,
        similarTestReproduceList: {
          ...state.similarTestReproduceList,
          isLoading: true,
        },
      };
    }

    case FETCH_SIMILAR_TEST_REPRODUCE_LIST_SUCCESS: {
      const testData = action?.result?.data;
      return {
        ...state,
        similarTestReproduceList: {
          ...state.similarTestReproduceList,
          isLoading: false,
          data: testData,
          selectedTest: testData?.tests?.[0]?.id,
        },
      };
    }

    case FETCH_SIMILAR_TEST_REPRODUCE_LIST_FAILED: {
      return {
        ...state,
        similarTestReproduceList: {
          ...state.similarTestReproduceList,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case UPDATE_SELECTED_TEST_TO_REPRODUCE: {
      return {
        ...state,
        similarTestReproduceList: {
          ...state.similarTestReproduceList,
          selectedTest: action?.payload,
        },
      };
    }

    case UPDATE_SELECTED_TEST_TO_RETRY: {
      return {
        ...state,
        similarTestRetryList: {
          ...state.similarTestRetryList,
          selectedTest: action?.payload,
        },
      };
    }

    case FETCH_TEST_RETRY_HISTORY_LOADING: {
      return {
        ...state,
        testRetryHistory: {
          ...state.testRetryHistory,
          isLoading: true,
        },
      };
    }

    case FETCH_TEST_RETRY_HISTORY_SUCCESS: {
      return {
        ...state,
        testRetryHistory: {
          ...state.testRetryHistory,
          isLoading: false,
          data: action?.result?.data,
        },
      };
    }

    case FETCH_TEST_RETRY_HISTORY_FAILED: {
      return {
        ...state,
        testRetryHistory: {
          ...state.testRetryHistory,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case FETCH_TEST_REPRODUCE_HISTORY_LOADING: {
      return {
        ...state,
        testReproduceHistory: {
          ...state.testReproduceHistory,
          isLoading: true,
        },
      };
    }

    case FETCH_TEST_REPRODUCE_HISTORY_SUCCESS: {
      return {
        ...state,
        testReproduceHistory: {
          ...state.testReproduceHistory,
          isLoading: false,
          data: action?.result?.data,
        },
      };
    }

    case FETCH_TEST_REPRODUCE_HISTORY_FAILED: {
      return {
        ...state,
        testReproduceHistory: {
          ...state.testReproduceHistory,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case UPDATE_TEST_DETAILS_LOADING: {
      return {
        ...state,
        updateTestDetails: {
          ...state.updateTestDetails,
          isLoading: true,
        },
      };
    }

    case UPDATE_TEST_DETAILS_SUCCESS: {
      return {
        ...state,
        updateTestDetails: {
          ...state.updateTestDetails,
          isLoading: false,
          data: action?.result?.data,
        },
      };
    }

    case UPDATE_TEST_DETAILS_FAILED: {
      return {
        ...state,
        updateTestDetails: {
          ...state.updateTestDetails,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case UPDATE_TEST_ATTEMPTS: {
      const testHistoryData = state.testHistory?.data?.tests;
      const { testName = '', testId = '', status = '' } = action?.payload || {};
      if (testHistoryData) {
        const foundIndex = testHistoryData.findIndex(
          (test) => test.id == testId
        );
        if (foundIndex !== -1) {
          testHistoryData[foundIndex].name = testName;
          if (status) {
            testHistoryData[foundIndex].status = status;
          }
        }
      }
      return {
        ...state,
        testHistory: {
          ...state.testHistory,
          data: {
            total: state.testHistory?.data?.total,
            tests: testHistoryData,
          },
        },
      };
    }

    case RERUN_TEST_LOADING: {
      return {
        ...state,
        rerunTest: {
          ...state.rerunTest,
          isLoading: true,
          error: null,
        },
      };
    }

    case RERUN_TEST_SUCCESS: {
      return {
        ...state,
        rerunTest: {
          ...state.rerunTest,
          isLoading: false,
          data: action?.result?.data,
        },
      };
    }

    case RERUN_TEST_FAILED: {
      return {
        ...state,
        rerunTest: {
          ...state.rerunTest,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case LAMBDATEST_PARENT_TEST_DETAIL_LOADING: {
      return {
        ...state,
        parentTestDetailHash: {
          ...state.parentTestDetailHash,
          isLoading: true,
        },
      };
    }

    case LAMBDATEST_PARENT_TEST_DETAIL_SUCCESS: {
      return {
        ...state,
        parentTestDetailHash: {
          ...state.parentTestDetailHash,
          isLoading: false,
          data: action?.result?.data,
        },
      };
    }

    case LAMBDATEST_PARENT_TEST_DETAIL_FAILED: {
      return {
        ...state,
        parentTestDetailHash: {
          ...state.parentTestDetailHash,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case RESET_SIMILAR_TEST_LIST: {
      return {
        ...state,
        similarTestRetryList: {
          data: [],
          error: null,
          isLoading: false,
          selectedTest: null,
        },
        similarTestReproduceList: {
          data: [],
          error: null,
          isLoading: false,
          selectedTest: null,
        },
      };
    }

    case RESET_ACTIVE_TUNNEL_LIST: {
      return {
        ...state,
        activeTunnelList: {
          data: [],
          error: null,
          isLoading: false,
        },
      };
    }

    case CLEAR_RERUN_TEST_HISTORY: {
      return {
        ...state,
        testReproduceHistory: {
          data: {},
          error: null,
          isLoading: false,
        },
        testRetryHistory: {
          data: {},
          error: null,
          isLoading: false,
        },
      };
    }

    case SET_RERUN_TYPE: {
      return {
        ...state,
        rerunType: action.payload,
      };
    }

    case SET_IS_RERUN_PAGE: {
      const isTestRerunPage = action.payload;
      return {
        ...state,
        isTestRerunPage,
      };
    }

    case SET_IS_RERUN_EDIT_CAPABILITY_MODE: {
      const isRerunEditCapabilityEnabled = action.payload;
      return {
        ...state,
        isRerunEditCapabilityEnabled,
      };
    }

    case SET_IS_RERUN_ADVANCED_SETTINGS_MODE: {
      const isRerunAdvancedSettingsEnabled = action.payload;
      return {
        ...state,
        isRerunAdvancedSettingsEnabled,
      };
    }

    case SET_RERUN_FULLSCREEN_MODE: {
      const fullScreenMode = action.payload;
      return {
        ...state,
        fullScreenMode,
      };
    }

    case SET_RERUN_TEST_DETAILS: {
      const { key, value } = action.payload;
      return {
        ...state,
        rerunTestDetails: {
          ...state.rerunTestDetails,
          [key]: value,
        },
      };
    }

    case CLEAR_RERUN_TEST_DETAILS: {
      return {
        ...state,
        isRerunEditCapabilityEnabled: false,
        isRerunAdvancedSettingsEnabled: false,
        fullScreenMode: false,
        unsavedCapability: null,
        rerunTestDetails: {
          speed: 1,
          breakpoints: [],
        },
      };
    }

    case STOP_REPLAY_TEST_LOADING: {
      return {
        ...state,
        stopTest: {
          ...state.stopTest,
          isLoading: true,
          error: null,
        },
      };
    }

    case STOP_REPLAY_TEST_SUCCESS: {
      return {
        ...state,
        stopTest: {
          ...state.stopTest,
          isLoading: false,
          data: action?.result?.data,
        },
      };
    }

    case STOP_REPLAY_TEST_FAILED: {
      return {
        ...state,
        stopTest: {
          ...state.stopTest,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case PAUSE_REPLAY_TEST_LOADING: {
      return {
        ...state,
        pauseTest: {
          ...state.pauseTest,
          isLoading: true,
          error: null,
        },
      };
    }

    case PAUSE_REPLAY_TEST_FAILED: {
      return {
        ...state,
        pauseTest: {
          ...state.pauseTest,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case PAUSE_REPLAY_TEST_SUCCESS: {
      return {
        ...state,
        pauseTest: {
          ...state.pauseTest,
          isLoading: false,
          data: action?.result?.data,
        },
      };
    }

    case RESUME_REPLAY_TEST_LOADING: {
      return {
        ...state,
        resumeTest: {
          ...state.resumeTest,
          isLoading: true,
          error: null,
        },
      };
    }

    case RESUME_REPLAY_TEST_SUCCESS: {
      return {
        ...state,
        resumeTest: {
          ...state.resumeTest,
          isLoading: false,
          data: action?.result?.data,
        },
      };
    }

    case RESUME_REPLAY_TEST_FAILED: {
      return {
        ...state,
        resumeTest: {
          ...state.resumeTest,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case STEPOVER_REPLAY_TEST_LOADING: {
      return {
        ...state,
        stepoverCommand: {
          ...state.stepoverCommand,
          isLoading: true,
          error: null,
        },
      };
    }

    case STEPOVER_REPLAY_TEST_SUCCESS: {
      return {
        ...state,
        stepoverCommand: {
          ...state.stepoverCommand,
          isLoading: false,
          data: action?.result?.data,
        },
      };
    }

    case STEPOVER_REPLAY_TEST_FAILED: {
      return {
        ...state,
        stepoverCommand: {
          ...state.stepoverCommand,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case DEBUGGER_STATE_LOADING: {
      return {
        ...state,
        debuggerState: {
          ...state.debuggerState,
          isLoading: true,
          error: null,
        },
      };
    }

    case DEBUGGER_STATE_SUCCESS: {
      const debuggerData = action?.result?.data?.message || {};
      const { speed, replayDebuggerState = {} } = debuggerData || {};
      const { current_debugger_state = '', current_parent_request_id = '' } =
        replayDebuggerState || {};

      return {
        ...state,
        debuggerState: {
          ...state.debuggerState,
          isLoading: false,
          speed: speed || 1,
          currentDebuggerState: current_debugger_state,
          currentParentRequestId: current_parent_request_id,
        },
      };
    }

    case DEBUGGER_STATE_FAILED: {
      return {
        ...state,
        debuggerState: {
          ...state.debuggerState,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case MODIFY_BREAKPOINT_LOADING: {
      return {
        ...state,
        modifyBreakpoint: {
          ...state.modifyBreakpoint,
          isLoading: true,
          error: null,
        },
      };
    }

    case MODIFY_BREAKPOINT_SUCCESS: {
      return {
        ...state,
        modifyBreakpoint: {
          ...state.modifyBreakpoint,
          isLoading: false,
          data: action?.result?.data,
        },
      };
    }

    case MODIFY_BREAKPOINT_FAILED: {
      return {
        ...state,
        modifyBreakpoint: {
          ...state.modifyBreakpoint,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case FETCH_ALL_BREAKPOINTS_LOADING: {
      return {
        ...state,
        breakpointDetails: {
          ...state.breakpointDetails,
          isLoading: true,
          error: null,
        },
      };
    }

    case FETCH_ALL_BREAKPOINTS_SUCCESS: {
      const breakpointList = action?.result?.data?.message?.breakpoints || [];

      return {
        ...state,
        breakpointDetails: {
          ...state.breakpointDetails,
          isLoading: false,
          data: breakpointList,
        },
      };
    }

    case FETCH_ALL_BREAKPOINTS_FAILED: {
      return {
        ...state,
        breakpointDetails: {
          ...state.breakpointDetails,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case UPDATE_PLAYBACK_SPEED_LOADING: {
      return {
        ...state,
        updatePlaybackSpeed: {
          ...state.updatePlaybackSpeed,
          isLoading: true,
          error: null,
        },
      };
    }

    case UPDATE_PLAYBACK_SPEED_SUCCESS: {
      return {
        ...state,
        updatePlaybackSpeed: {
          ...state.updatePlaybackSpeed,
          isLoading: false,
          data: action?.result?.data,
        },
      };
    }

    case UPDATE_PLAYBACK_SPEED_FAILED: {
      return {
        ...state,
        updatePlaybackSpeed: {
          ...state.updatePlaybackSpeed,
          isLoading: false,
          error: action.error,
        },
      };
    }

    case UPDATE_DEBUGGER_STATE: {
      const { linkedRequestId, currentDebuggerState } = action.payload || {};
      return {
        ...state,
        debuggerState: {
          ...state.debuggerState,
          currentParentRequestId: linkedRequestId, // represents the linked request id when test is paused/resumed
          currentDebuggerState: currentDebuggerState, // represents current debugger test state when test is replayed/reproduced
        },
      };
    }

    case UPDATE_COMMAND_BREAKPOINT: {
      return {
        ...state,
        breakpointDetails: {
          ...state.breakpointDetails,
          data: action.payload,
        },
      };
    }

    case UPDATE_UNSAVED_CAPABILITY: {
      return {
        ...state,
        unsavedCapability: action.payload,
      };
    }

    default:
      return state;
  }
}
